import { Button, Image, Skeleton, Tag } from "antd";
import React, { useRef } from "react";
import Container from "../../General/Container/Container";
import { DownloadOutlined, ReloadOutlined } from "@ant-design/icons";
import PersonasInfoGroup from "./PersonasInfoGroup";
import { useEffect } from "react";
import PersonasImageReset from "./PersonasImageReset";
import { capitalize, formatNumber } from "../../../utils/MainHelper";

export const getPersonasName = (data) => {
    return data?.["Full Name"] || "";
}
const PersonasBasicInfo = ({
    loadingImage,
    loading,
    classColor,
    onClickDownloadPDF = () => { },
    onClickReloadPersona = () => { },
    data,
    image,
    forPrint,
    targetSize
}) => {
    const basicInfoRef = useRef()

    const profileData = ["Age", "Location", "Education"].map((key) => ({
        label: key,
        value: data?.[key] || "Undetermined"
    }))

    const demographicsData = Object.keys(data?.Demographics || {}).map((key) => ({
        label: key,
        value: data?.["Demographics"]?.[key] || "Undetermined"
    }))

    const getPersonalityTraits = () => {
        return data?.Psychographics?.["Personality Traits"].map((text) => {
            return <Tag className={`personas-tag${classColor}`}>{capitalize(text.trim())}</Tag>
        })
    }
    const forPrintStyle = forPrint ? { width: "calc(50% - 2rem)" } : { width: "calc(25% - 2mm)" }
    useEffect(() => {
        if (basicInfoRef.current) {
            basicInfoRef.current.scrollIntoView()
        }
    }, basicInfoRef)
    return <Container className="fcol download-personas" ref={basicInfoRef}>
        <Container className="drow gap-1">
            {loadingImage
                ? <Skeleton.Button active style={{
                    width: "69mm", height: "89mm"
                }} />
                : <Container
                    className={image === "error" ? "drow align-center justify-center minified-result-item" : "persona-image"}
                    style={{ width: "69mm", height: "89mm", overflow: "hidden", background: "white" }}>
                    {image === "error"
                        ? <PersonasImageReset data={data} forPrint={forPrint} />
                        : <Image style={{ width: "100%", height: "100%", objectFit: "contain" }} src={image} preview={!forPrint} />
                    }
                </Container>
            }
            <Container className="minified-result-item dcol flex-1">
                <Container className="drow justify-between">
                    <Container className="dcol">
                        {loading
                            ? null : <>
                                <span className={`personas-name${classColor}`}>{getPersonasName(data)}</span>
                                <span className="personas-text">{data?.["Occupation"]}</span>
                            </>}
                    </Container>
                    {forPrint || loadingImage || loading ? null
                        : <Container className="drow gap-1 align-center">
                            <Button icon={<ReloadOutlined />} type="text" onClick={onClickReloadPersona}>Reload</Button>
                            <Button icon={<DownloadOutlined />} type="text" onClick={onClickDownloadPDF}>Download PDF</Button>
                        </Container>}
                </Container>
                <Container className={`${forPrint ? "dwrap" : "drow"} gap-2`}>
                    <PersonasInfoGroup
                        title="Profile"
                        list={profileData}
                        classColor={classColor}
                        loading={loading}
                        style={forPrintStyle}
                    />
                    <PersonasInfoGroup
                        title="Demographics"
                        list={demographicsData}
                        classColor={classColor}
                        loading={loading}
                        style={forPrintStyle}
                    />
                    <PersonasInfoGroup
                        title="Personality Traits"
                        classColor={classColor}
                        style={forPrintStyle}
                        loading={loading}
                    >
                        <Container className="dwrap gap-1">
                            {getPersonalityTraits()}
                        </Container>
                    </PersonasInfoGroup>
                    <PersonasInfoGroup
                        title="Target Size"
                        classColor={classColor}
                        style={forPrintStyle}
                        loading={loading}
                    >
                        <span className={`personas-targetsize-value${classColor}`} style={{ width: "fit-content" }}>
                            {formatNumber(targetSize || 0)}
                        </span>
                    </PersonasInfoGroup>
                </Container>
            </Container>
        </Container>
    </Container>
}

export default PersonasBasicInfo